"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BadgeColors = void 0;
var _mui = require("@ori-ui/mui");
const BadgeColors = exports.BadgeColors = {
    General: _mui.theme.palette.grey[300],
    EndConsumerOrders: _mui.theme.palette.info.main,
    BackOrders: _mui.theme.palette.grey[300],
    Campaign: _mui.theme.palette.secondary.light,
    WelcomeProgram: _mui.theme.palette.secondary.light,
    Offer: _mui.theme.palette.offer.main
};
